export default "__VITE_ASSET__jnsjk_kk__"